module.exports = __webpack_public_path__ + "static/img/10-1.df0645b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/10-1.jpg
// module id = CIKh
// module chunks = 0